import { ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import theme from './theme';
import { LoadingProvider, ToastProvider } from './context';
import { ToastInitializer } from './components/toast-initializer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <LoadingProvider>
        <ToastProvider>
          <ToastInitializer />
          <RouterProvider router={router} />
        </ToastProvider>
      </LoadingProvider>
    </ThemeProvider>
  );
}

export default App;
